import React from 'react';
import { PopoverAnchor, usePopoverContext } from '@fiverr-private/popover';
import { useEnteredView } from '@fiverr-private/hooks';
import type { EducationTooltipAnchorProps } from '../types';
import { useEducationTooltipContext } from '../EducationTooltipContext';

const EducationTooltipAnchor = ({ children, as = 'span', fullWidth }: EducationTooltipAnchorProps) => {
  const { floatingData } = usePopoverContext();
  const { setInView } = useEducationTooltipContext();
  useEnteredView(floatingData?.refs?.reference as React.RefObject<Element>, {
    onEntered: () => setInView(true),
    threshold: 0,
  });

  return (
    <PopoverAnchor as={as} fullWidth={fullWidth}>
      {children}
    </PopoverAnchor>
  );
};

EducationTooltipAnchor.displayName = 'EducationTooltipAnchor';

export default EducationTooltipAnchor;
